import { ErrorBoundary } from './components/index.js'
import { AuthGuard } from './features/auth/index.js'
import { AppShell } from './features/chat/index.js'

export function App() {
  return (
    <ErrorBoundary>
      <AuthGuard>
        <AppShell />
      </AuthGuard>
    </ErrorBoundary>
  )
}
